import { lazyRetry } from "helpers/lazyRetry";

const LiquidationOtherProducts_L = lazyRetry(() => import("./LiquidationOtherProducts"));

export default LiquidationOtherProducts_L;
